import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { AzavistaApiService } from '@azavista/servicelib';
import { TranslateService } from '@ngx-translate/core';
import { MyAccountService } from 'src/app/my-account/my-account.service';
import { SharedService } from '../shared.service';
import { LocalStorageKey } from '../enums';

@Component({
    selector: 'azavista3-public-page-container',
    templateUrl: './public-page-container.component.html',
    styleUrls: [
        './public-page-container.component.scss'
    ],
    standalone: false
})
export class PublicPageContainerComponent implements OnInit {
    @Input() iframeUrl = 'https://marketing.azavista.com/w/event/65c6153abbbe676defbfd4fc/';
    @Input() homePageUrl = 'https://www.azavista.com/';

    corporateLoginUrl = this.sharedSvc.getWebsiteUrl('/auth/login');
    availableLanguages = this.userAccountSvc.languages;
    language = this.getInitLanguage();

    constructor(
        private sanitizer: DomSanitizer,
        private sharedSvc: SharedService, private translateSvc: TranslateService,
        private userAccountSvc: MyAccountService,
        private apiSvc: AzavistaApiService, private router: Router, private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.onLanguageSelected(this.language);
    }

    sanitize = (url: string) => {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };

    getInitLanguage(): string {
        const localStorageLanguage = window.localStorage.getItem(LocalStorageKey.userLanguage);
        if (localStorageLanguage) {
            return localStorageLanguage;
        }
        const browserLanguage = this.translateSvc.getBrowserLang();
        const supportedBrowserLanguage = this.availableLanguages.find(x => x.id.includes(browserLanguage));
        if (supportedBrowserLanguage.id) {
            return supportedBrowserLanguage.id;
        }
        const platformDefaultLanguage = this.translateSvc.getDefaultLang();
        return platformDefaultLanguage;
    }

    onLanguageSelected(lang: string): void {
        this.translateSvc.setDefaultLang(lang);
        this.translateSvc.use(lang);
        window.localStorage.setItem(LocalStorageKey.userLanguage, lang);
    }

}
